import * as React from "react";
import {
  Grid,
  TextField,
  OutlinedTextFieldProps,
  useTheme,
} from "@material-ui/core";
import axios, {AxiosResponse} from "axios";
import PhoneNumber from "awesome-phonenumber";
import { MUICountryCodesSelect } from "..";
import { countryCodes } from "./codes";

interface IProps extends Omit<OutlinedTextFieldProps, "onChange"> {
  withoutPadding?: boolean;
  onChange: (phoneData: { value: string; isValid: boolean, countryCode: string }) => void;
}

export interface MUIPhoneInputResult {
  value: string;
  isValid: boolean;
  countryCode: string;
}

interface ipResponse {
  ip: string,
  country: string
}

export const MUIPhoneInput = (props: IProps) => {
  const theme = useTheme();

  const [value, setValue] = React.useState<string>("");
  const [countryCode, setCountryCode] = React.useState<string>("ru");
  const [isValid, setValid] = React.useState<boolean>(false);

  // При начальном рендере компонента пытаемся получить данные о стране пользователя
  React.useEffect(() => {
    const url = '/api/geo/country';
    axios
      .get(url)
      .then((response: AxiosResponse<ipResponse>) => {
        if (response.data.country) {
          setCountryCode(response.data.country.toLowerCase());
          const found = countryCodes.find(c => c.name === response.data.country.toLowerCase());
          if (found) {
            setValue(`${found.code}`);
          }
        }
      })
  }, []);

  const countrySelectHandler = (value: string) => {
    const found = countryCodes.find(c => c.name === value);

    setCountryCode(value);
    setValue(`${found.code}`);
  };

  const parsePhone = React.useCallback(
    (dirtyValue: string) => {
      const cleanValue = dirtyValue.replace(/\D/g, "");
      const intlValue = cleanValue ? `+${cleanValue}` : "+";
      const phone = new PhoneNumber(intlValue);
      if (phone.toJSON().possibility === "too-long") {
        return value;
      }
      setCountryCode(phone.getRegionCode()?.toLowerCase() || "ru");
      setValid(phone.isValid());
      return phone.getNumber("international") || intlValue;
    },
    [value]
  );

  React.useEffect(() => {
    props.onChange({ value, isValid, countryCode });
  }, [value]);

  return (
    <Grid item container spacing={props.withoutPadding ? 0 : 2}>
      <Grid
        item
        xs={3}
        sm={3}
      >
        <MUICountryCodesSelect
          countryCodes={countryCodes}
          value={countryCode}
          onChange={countrySelectHandler}
          onlyFlag
        />
      </Grid>
      <Grid
        item
        xs={9}
        sm={9}
      >
        <TextField
          autoComplete="tel"
          type="tel"
          placeholder="999 999 99 99"
          {...props}
          value={value}
          onChange={(evt) => {
            setValue(parsePhone(evt.target.value));
          }}
        />
      </Grid>    
    </Grid>
  );
};
